import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-template-builder',
  templateUrl: './template-builder.component.html',
  styleUrls: ['./template-builder.component.scss']
})
export class TemplateBuilderComponent implements OnInit {

  @Input() children;
  @Input() elements;
  constructor() {}

  ngOnInit() {
    this.children.forEach(c => {
      if(c.element) {
        this.getElementPreview(c.element)
      }
    });
  }

  getElement(e) {
    return this.elements[e];
  }

  getElementPreview(e) {
    let element = this.getElement(e);
    if(element && element.preview) {
      return this.getElement(element.preview);
    } else {
      return null;
    }
  }

}
